(ns frontend.actions.attachment
  (:require-macros [cljs.core.async.macros :as async])
  (:require [cljs.core.async :as a]
            [cljs-http.client :as http]
            [frontend.conn :as conn]
            [frontend.updates.entity-scope :as entity-scope]
            [promesa.core :as p]))

;; Fat arrows => REST
;; Thin arrows -> WS
;; Directions <- GET, DELETE, fetch data
;;            -> PUT, POST, push data

(defn *=>add-attachment [data on-success! on-error!]
  (async/go
   (let [resp (a/<! (http/post "/attachment/api/add-attachment"
                               data))]
     (if (= (:status resp) 200)
       (let [body (:body resp)]
         ;; The upload response has only the attachment id. A new-grid account
         ;; gets no attachments from the sync channels. Fetch the attachment and
         ;; its owner before the caller reads them from the session.
         ;; The endpoint wraps the attachment in a second `:body`.
         (entity-scope/hydrate! {:entity-id (get-in body [:body :db/id])
                                 :on-done   (fn [] (on-success! body))}))
       (on-error! (:body resp))))))

(defn *<-remove-attachment [data on-success! on-error!]
  (-> (conn/sendp! :common/remove-attachment
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->upload-public-file! [data on-success! on-error!]
  (async/go
   (let [resp (a/<! (http/post "/attachment/api/upload-public-file!"
                               data))]
     (if (= (:status resp) 200)
       (on-success! (:body resp))
       (on-error! (:body resp))))))

(defn *->copy-to [attachment-id target-id on-success! on-error!]
  (-> (conn/sendp! :attachment/copy-to
                   {:attachment-id attachment-id
                    :target-id     target-id})
      (p/then on-success!)
      (p/catch on-error!)))
